import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useRedux';
import RSAKeySelfHealing from './RSAKeySelfHealing';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { user } = useAppSelector((state) => state.auth);

    // With cookie-based authentication, we only need to check if user exists
    // The HttpOnly session cookie will be automatically sent with API requests
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return (
        <>
            {children}
            <RSAKeySelfHealing />
        </>
    );
};

export default ProtectedRoute;